/**
 * Database type.
 */
export type DatabaseType =
    | "mysql"
    | "postgres"
    | "mariadb"
    | "sqlite"
    | "sqlite-pooled"
